// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","order-number":"styles_order-number__+umsW","order-number__icon":"styles_order-number__icon__tebmL","order-number__span":"styles_order-number__span__g7APt"};